import axios from "axios";

let Bearer;
export const getBearer = () => Bearer;

export const setBearer = (value) => { Bearer = value };

export const privatePost = async function ({ api, data }, callback, target) {
    if (!Bearer) { return callback("not Set Bearer", null); }

    let server = process.env.REACT_APP_API_URL;
    let options =
    {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': Bearer,
        }, withCredentials: true
    }

    if (process.env.REACT_APP_SERVICE === "TEST") {// 빌드할때는 주석
        server = process.env.REACT_APP_API_URL_TEST;
        options =
        {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        }
    }

    const url = `${server}${api}`;
    // console.log(api);
    // console.log("Start_X",options);

    await axios.post(url, data, options)
        .then((response) => {
            if (response?.data?.error) return callback(response.data.error, null);
            // console.log("end",api);

            // console.log("target / " + target + " api / "+api);
            // console.log("response",response);

            return callback(null, response);
        }).catch((err) => {
            return callback(err, null);
        }).finally(() => {

        });

}

export const post = async function ({ api, data }, callback) {

    let server = process.env.REACT_APP_API_URL;
    let options =
    {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        withCredentials: true
    }

    if (process.env.REACT_APP_SERVICE === "TEST") {
        server = process.env.REACT_APP_API_URL_TEST;
    }

    const url = `${server}${api}`;

    await axios.post(url, data, options)
        .then((response) => {
            if (response?.data?.error) return callback(response.data.error, null);
            // console.log(api);

            return callback(null, response);
        }).catch((err) => {
            return callback(err, null);
        }).finally(() => {
        });
};



// export const ipGet = async function (callback) {
    
//     const test = navigator.language ;
//     console.log(test);
//     // axios.get('https://extreme-ip-lookup.com/json')
//     // .then(res => {
//     //     console.log(res.data);
//     //     return callback(null, res.data);
//     // })
// }; 